import apiClient from './apiClient';

// ─── Response Normalizer ──────────────────────────────────────────────────────
/**
 * Normalises the various response shapes the API may return:
 *   - { data: [...], meta: {...} }
 *   - { items: [...], total: 0 }
 *   - [...]  (bare array)
 */
export const normalizeResponse = (response) => {
  if (!response) return { data: [], meta: {} };
  if (Array.isArray(response)) return { data: response, meta: {} };

  return {
    data: response.data || response.items || [],
    meta: response.meta || { total: response.total ?? 0, totalRecords: response.total ?? 0 },
  };
};

// ─── Repository Functions ─────────────────────────────────────────────────────
export const getBusinessById = (businessId) => apiClient.get(`/businesses/${businessId}`);
export const createBusiness = (businessData) => apiClient.post('/businesses', businessData);
export const updateBusiness = (businessId, businessData) => apiClient.patch(`/businesses/${businessId}`, businessData);
export const getQRPlateData = (businessId) => apiClient.get(`/business-qr-plates?businessId=${businessId}`);
export const getAssets = (businessId) => apiClient.get(`/asset/business/${businessId}`);
export const getBanners = (businessId) => apiClient.get(`/banners/business/${businessId}?isActive=true`);

export const getUserBusinesses = async (page = 1, take = 10) => {
  const response = await apiClient.get(`/businesses/my?page=${page}&take=${take}`);
  return normalizeResponse(response);
};

export const deleteBusiness = (businessId) => apiClient.delete(`/businesses/${businessId}`);

export const getBusinesses = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v, i) => query.append(`${key}[${i}]`, v));
    } else if (value !== undefined && value !== null) {
      query.append(key, value);
    }
  });
  return apiClient.get(`/businesses?${query.toString()}`);
};

export const getCategories = () => apiClient.get('/business-categories');
export const getExploreCategories = () => apiClient.get('/explore-categories');
export const getAvailableTag = (tag) => apiClient.get(`/businesses/available-tag/${encodeURIComponent(tag)}`);
export const getBusinessRatings = (businessId, page = 1, take = 10) => apiClient.get(`/business-ratings/${businessId}?page=${page}&take=${take}`);
